import { Component, OnInit, ViewChild } from '@angular/core';
import { SectorProfitDataComponent } from 'app/industry-level/sector-profit-data/sector-profit-data.component';
import { CpmService } from 'app/service/cpm.service';
import { environment } from '../../../environments/environment';
import { ExportExcelService } from '../../service/export-excel.service';
@Component({
  selector: 'app-sector-profit',
  templateUrl: './sector-profit.component.html',
  styleUrls: ['./sector-profit.component.scss']
})
export class SectorProfitComponent implements OnInit {
  @ViewChild(SectorProfitDataComponent)
  sectorProfitDataComponent: SectorProfitDataComponent;

  constructor(
    private cpmService: CpmService,
    private excelService: ExportExcelService
  ) { }

  ngOnInit() { }

  exportFunctionsSectorProfit() {
    const arrayOfFunctions: Map<String, Function> = new Map<String, Function>();
    arrayOfFunctions.set(
      'email',
      this.exportEmailSectorProfit(
        this.cpmService,
        this.sectorProfitDataComponent.viewValue
      )
    );

    arrayOfFunctions.set(
      'print',
      this.exportPrintSectorProfit(
        this.sectorProfitDataComponent.viewValue
      )
    );

    arrayOfFunctions.set(
      'pdf',
      this.exportPdfSectorProfit(
        this.sectorProfitDataComponent.viewValue
      )
    );

    arrayOfFunctions.set(
      'excel',
      this.exportExcelSectorProfit(
        this.sectorProfitDataComponent
      )
    );

    return arrayOfFunctions;
  }

  exportEmailSectorProfit(service, viewValue) {
    return function mailProfit() {
      service.saveSectorProfitDataPdfFile(viewValue).then(filename => {
        const subject = 'SectorProfit-Data';
        const downloadUrl = encodeURIComponent(
          `${environment.cpmBaseUrl}/download?type=report&filename=${filename}`
        );
        window.location.href = `mailto:?subject=${subject}&body=${downloadUrl}`;
      });
    };
  }

  exportPrintSectorProfit = function (viewValue) {
    return function ProfitPrint() {
      const popupWin = window.open(
        `/#/sectorProfitData/${viewValue}`,
        '_blank',
        'width=850px,height=1024px'
      );
    };
  };

  exportPdfSectorProfit = function (viewValue) {
    const service = this.cpmService;
    return function ProfitPdf() {
      service.downloadFile(
        `${environment.cpmBaseUrl}/pdf/sectorProfitData?viewValue=${viewValue}`
      );
    };
  };

  exportExcelSectorProfit(  sectorProfitDataComponent) {
    return function excelProfit() {
      sectorProfitDataComponent.dataToExcel();
      //  service.exportExcelSectorIndexandProfit(sectorProfitDataComponent.ws_data, 'Sector index & Profit')
    };
  };


  // sectorProfitEexcel() {
  //   this.sectorProfitDataComponent.dataToExcel();
  // }

}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/industry-level/sector-profit/sector-profit.component.ts